import React from "react";
import success from "../../../images/success.png";
import { Link } from "react-router-dom";
import "./Success.css";

const Success = () => {
  const decor = {
    textDecoration: "none",
  };

  return (
    <div className="success-container">
      <div className="success-wrapper">
        <div className="success-img">
          <img src={success} alt="successimg" />
        </div>
        <div className="success-div">
          <h4 className="success-info">Account Created Successfully</h4>
          <p>A verification email has just been sent to your email</p>
          <Link style={decor} to="/login" className="reg-info success-login">
          <div className="login-btn">
            <button type="submit" className="login-button">
              Login
            </button>
          </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Success;
